import c from "classnames";
import { PropsWithChildren } from "react";

import classes from "./ScrollBox.module.css";

type Props = PropsWithChildren<{
  stretch?: boolean;
  center?: boolean;
  height?: number;
}>;

export const ScrollBox = ({
  stretch = false,
  center = false,
  height,
  ...rest
}: Props) => {
  return (
    <div
      className={c(
        classes.scrollBox,
        stretch && classes.stretch,
        center && classes.center,
      )}
      style={{ height: height ? `${height}px` : undefined }}
      {...rest}
    />
  );
};
